import * as SelectPrimitive from "@radix-ui/react-select";
import { ComponentProps } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { useBusinessCentralCompanyListQuery } from "@/services/backend/business-central/api/company-api";

export function BusinessCentralCompanySelect({
  ...props
}: ComponentProps<typeof SelectPrimitive.Root>) {
  const { data } = useBusinessCentralCompanyListQuery({});
  return (
    <Select {...props}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Unternehmen auswählen" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {data?.value.map((company) => (
            <SelectItem value={company.id} key={company.id}>
              {company.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
